import { GlobalController } from 'src/shared/global/GlobalController'
import ServiceRequestInvoice from './ServiceRequestInvoice'
import ServiceRequestSimpleAgreementController from './simpleAgreement/ServiceRequestSimpleAgreementController.vue'
import ServiceRequestDebitStatement from './debit-statement/ServiceRequestDebitStatement'
import ServiceRequestValuesToCompensate from './values-to-compensate/ServiceRequestValuesToCompensate'
import ServiceRequestInvoiceSettlement from './invoice-settlement/ServiceRequestInvoiceSettlement'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'finalcial/invoice',
    name:
      'serviceRequest.financial.invoice',
    component: ServiceRequestInvoice,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  },
  {
    path: 'finalcial/simple-agreements',
    name:
      'serviceRequest.financial.simple-agreements',
    component: ServiceRequestSimpleAgreementController,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  },
  {
    path: 'finalcial/debit-statements',
    name:
      'serviceRequest.financial.debit-statements',
    component: ServiceRequestDebitStatement,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  },
  {
    path: 'finalcial/values-to-compensate',
    name:
      'serviceRequest.financial.values-to-compensate',
    component: ServiceRequestValuesToCompensate,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  },
  {
    path: 'finalcial/invoice-settlement',
    name:
      'serviceRequest.financial.invoice-settlement',
    component: ServiceRequestInvoiceSettlement,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  }
]
